import { MERMAID_RESET_STYLES } from './constants';

declare global {
  interface Window {
    mermaid: any; // eslint-disable-line
  }
}

const getShadowRoot = (root: Element) => {
  let shadowRoot = root.shadowRoot;

  if (!shadowRoot) {
    root.attachShadow({ mode: 'open' });
    shadowRoot = root.shadowRoot!;
  }

  return shadowRoot;
};

export const initMermaid = (props: Record<string, unknown>) => {
  if (typeof window.mermaid !== 'undefined') {
    console.log('init mermaid');
    window.mermaid.initialize(props);
  }
};

export const renderMermaid = (
  def: string,
  element: Element,
  opts?: { wrapperEl?: string; wrapperClassName?: string }
) => {
  const mermaid = window.mermaid;
  const wrapperClassName = opts?.wrapperClassName || 'mm-shadow-root';

  if (typeof mermaid !== 'undefined') {
    let root = element.querySelector('.' + wrapperClassName);

    if (root) {
      element.removeChild(root);
    }

    root = document.createElement(opts?.wrapperEl || 'div');
    root.className = wrapperClassName;
    element.appendChild(root);

    const mermaidNodeId = 'mermaid';

    // eslint-disable-next-line
    mermaid.render(mermaidNodeId, def, root).then((svgCode: any) => {
      const shadowRoot = getShadowRoot(root);
      shadowRoot.innerHTML = svgCode.svg;

      const shadowRootStyles = [];
      const mermaidStyle = shadowRoot.querySelector('style');
      if (mermaidStyle) {
        shadowRootStyles.push(mermaidStyle);
      }

      const overrideStyle = document.createElement('style');
      overrideStyle.innerHTML = MERMAID_RESET_STYLES;
      shadowRootStyles.push(overrideStyle);

      shadowRoot.prepend(...shadowRootStyles);
      // mermaidStyle.remove();
    });

    return root;
  }
};
